(function ($, Drupal, drupalSettings) {

  Drupal.behaviors.webform = {
    attach: function (context, settings) {

      document.addEventListener("readystatechange", (event) => {
        if (event.target.readyState === "complete") {
          if ((settings.aero_sub_theme.webform == 'webform_submission_feedback_survey')) {
            if (settings.aero_sub_theme.webform == 'webform_submission_feedback_survey') {
              var webform = document.querySelector('form[id^="webform-submission-feedback-survey"]');
            }
                                   
            var submitClicked = false;

            if (webform) {
              const checkBoxes = webform.querySelectorAll('fieldset.checkboxes--wrapper.fieldgroup[data-once="webform-checkboxes-required"] input.form-checkbox.form-check-input');
              const webformSubmit = webform.querySelector('input.webform-button--submit');
              if (webformSubmit) {
                webformSubmit.addEventListener('click', function(event) {
                  event.stopPropagation();

                  var itemSelected = isItemSelected(checkBoxes);

                  if (itemSelected) {
                    clearCheckboxErrors(webform);
                  }
                });
              }

              if (checkBoxes) {
                checkBoxes.forEach((element) => {
                  element.addEventListener('click', function(event) {
                    event.stopPropagation();

                    submitClicked = webformSubmit.classList.contains('js-webform-submit-clicked');
                    if (submitClicked) {
                      var itemSelected = element.checked ? true : isItemSelected(checkBoxes);

                      if (itemSelected) {
                        clearCheckboxErrors(webform);
                      }
                    }
                  });
                });
              }

            }
          }
        }
      });

      function isItemSelected(checkBoxes) {
        itemSelected = false;
        checkBoxes.forEach((element) => {
          if (element.checked) {
            itemSelected = true;
          }
        });
        return itemSelected;
      }

      function clearCheckboxErrors(webform) {
        const errorItems = webform.querySelectorAll('fieldset.checkboxes--wrapper.fieldgroup[data-once="webform-checkboxes-required"] div.form-checkboxes div:first-child input ~ div.invalid-feedback');
        errorItems.forEach((el) => {
          el.remove();
        });
      }

    }
  };

})(jQuery, Drupal, drupalSettings);



